import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AssignmentPriorityProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'priority/assignment'
}
